import api from '../../api/_auth'
import apiConfig from '../../api/config/_user'

const state = () => ({
   authInfo: null,
   activeRole: null,

   auth_user: []
})

// getters
const getters = {
    authInfo: (state) =>{
        return state.authInfo
    },

    activeRole: (state) =>{
        return state.activeRole
    },

    auth_user: (state) =>{
        return state.auth_user
    },
}

// mutations
const mutations = {
    SET_CREDENTIALS(state, authInfo) {
        state.authInfo = authInfo;
    },

    SET_ACTIVE_ROLE(state, activeRole){
        state.activeRole = activeRole
    },

    SET_AUTH_USER(state, auth_user){
        state.auth_user = auth_user
    }
}

// actions
const actions = {

    login({commit},data){
        return new Promise((resolve, reject) =>{
            api.login(data).then(
                response => {
                    // L'API retourne l'utilisateur directement, on le wrappe pour compatibilité
                    const wrappedResponse = response.user ? response : { user: response }
                    commit('SET_CREDENTIALS', wrappedResponse)
                    resolve(wrappedResponse)
                    let index = 0
                    let roleToUse = null;
                    let defaultRole = null;
                    const roles = wrappedResponse.user.roles || []
                    for(index =0; index<roles.length;index++)
                    {
                         if(roles[index].pivot.is_active === 1 || roles[index].pivot.is_active === '1' || roles[index].pivot.is_active === true)
                         {
                            roleToUse = roles[index];
                            commit('SET_ACTIVE_ROLE',roleToUse)
                         }
                         if(roles[index].pivot.is_default === 1 || roles[index].pivot.is_default === '1' || roles[index].pivot.is_default === true )
                         {
                            defaultRole = roles[index];

                         }

                    }
                    if(roleToUse === null)
                    {
                        roleToUse = commit('SET_ACTIVE_ROLE',roleToUse);
                    }
                    console.log(defaultRole)
                }, error => {
                    reject(error);
                }
            )
        })
    },

    // login({commit},data){
    //     return new Promise((resolve, reject) =>{
    //         api.login(data).then(
    //             response => {
    //                 commit('SET_CREDENTIALS',response)
    //                 resolve(response)
    //                 console.log(response)
    //             }, error => {
    //                 console.log("-->>ERROR LOGIN ",error)
    //                 reject(error);
    //             }
    //         )
    //     })
    // },

    switchRole({commit},{userId,roleId}){
        return new Promise( (resolve,reject) =>{
            apiConfig.updateActiveRole(userId,roleId).then(
                response => {
                    resolve(response)
                    commit('SET_ACTIVE_ROLE',response)

                },error =>{
                    reject(error)
                }
            )
        })
    },

    getAuthUser({commit}, {user_id}) {
        return new Promise((resolve, reject) => {
            apiConfig.getAuthUser(user_id).then(
                response => {
                    resolve(response)
                    commit('SET_AUTH_USER', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}

export default {
  state,
  getters,
  actions,
  mutations
}